import { useTranslation } from 'react-i18next';

interface Props {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
}

/** Previous / next with «page N of M · total»: the one pagination of every list (CLAUDE.md §24). */
export function Pager({ page, pageSize, total, onPage }: Props) {
  const { t } = useTranslation();
  return (
    <div className="pager">
      <button
        type="button"
        className="btn sm"
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
      >
        {t('common.pagination.previous')}
      </button>
      <span className="mono">
        {t('common.pagination.summary', {
          page,
          pages: Math.max(1, Math.ceil(total / pageSize)),
          total,
        })}
      </span>
      <button
        type="button"
        className="btn sm"
        disabled={page * pageSize >= total}
        onClick={() => onPage(page + 1)}
      >
        {t('common.pagination.next')}
      </button>
    </div>
  );
}
